var _defs, _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 768,
    height: 768,
    viewBox: "0 0 768 768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-remove-color",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    colorInterpolationFilters: "sRGB",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-pattern-0",
    gradientUnits: "userSpaceOnUse",
    x1: -0.104895,
    y1: 1.104895,
    x2: 1.104895,
    y2: -0.104895,
    gradientTransform: "matrix(87.999998, 0, 0, 104.000002, 62.000003, 48.000005)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(100%, 18.03894%, 30.198669%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "rgb(100%, 18.03894%, 30.198669%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "rgb(100%, 18.193054%, 30.070496%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101562,
    stopColor: "rgb(100%, 18.516541%, 29.798889%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "rgb(100%, 18.858337%, 29.51355%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "rgb(100%, 19.198608%, 29.22821%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "rgb(100%, 19.540405%, 28.942871%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "rgb(100%, 19.880676%, 28.656006%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "rgb(100%, 20.222473%, 28.370667%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "rgb(100%, 20.562744%, 28.085327%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "rgb(100%, 20.904541%, 27.799988%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164062,
    stopColor: "rgb(100%, 21.244812%, 27.514648%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "rgb(100%, 21.586609%, 27.229309%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179687,
    stopColor: "rgb(100%, 21.92688%, 26.94397%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "rgb(100%, 22.268677%, 26.65863%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195312,
    stopColor: "rgb(100%, 22.608948%, 26.373291%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "rgb(100%, 22.949219%, 26.087952%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210937,
    stopColor: "rgb(100%, 23.291016%, 25.802612%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "rgb(100%, 23.631287%, 25.517273%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "rgb(100%, 23.973083%, 25.231934%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "rgb(100%, 24.313354%, 24.946594%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242187,
    stopColor: "rgb(100%, 24.655151%, 24.661255%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "rgb(100%, 24.995422%, 24.375916%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257812,
    stopColor: "rgb(100%, 25.337219%, 24.08905%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "rgb(100%, 25.67749%, 23.803711%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "rgb(100%, 26.019287%, 23.518372%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "rgb(100%, 26.359558%, 23.233032%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289062,
    stopColor: "rgb(100%, 26.701355%, 22.947693%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "rgb(100%, 27.041626%, 22.662354%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "rgb(100%, 27.383423%, 22.377014%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "rgb(100%, 27.723694%, 22.091675%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "rgb(100%, 28.065491%, 21.806335%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "rgb(100%, 28.405762%, 21.520996%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335937,
    stopColor: "rgb(100%, 28.747559%, 21.235657%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "rgb(100%, 29.08783%, 20.950317%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351562,
    stopColor: "rgb(100%, 29.429626%, 20.664978%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "rgb(100%, 29.769897%, 20.379639%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367187,
    stopColor: "rgb(100%, 30.111694%, 20.094299%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "rgb(100%, 30.451965%, 19.807434%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "rgb(100%, 30.793762%, 19.522095%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "rgb(100%, 31.134033%, 19.236755%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "rgb(100%, 31.47583%, 18.951416%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "rgb(100%, 31.816101%, 18.666077%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "rgb(100%, 32.157898%, 18.380737%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "rgb(100%, 32.498169%, 18.095398%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "rgb(100%, 32.839966%, 17.810059%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "rgb(100%, 33.180237%, 17.524719%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "rgb(100%, 33.522034%, 17.23938%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "rgb(100%, 33.862305%, 16.954041%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "rgb(100%, 34.202576%, 16.668701%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "rgb(100%, 34.544373%, 16.383362%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "rgb(100%, 34.884644%, 16.098022%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "rgb(100%, 35.22644%, 15.812683%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "rgb(100%, 35.566711%, 15.527344%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492775,
    stopColor: "rgb(100%, 35.908508%, 15.240479%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "rgb(100%, 36.079407%, 15.098572%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507225,
    stopColor: "rgb(100%, 36.248779%, 14.955139%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "rgb(100%, 36.419678%, 14.813232%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "rgb(100%, 36.590576%, 14.6698%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "rgb(100%, 36.930847%, 14.38446%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "rgb(100%, 37.272644%, 14.099121%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "rgb(100%, 37.612915%, 13.813782%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "rgb(100%, 37.954712%, 13.528442%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "rgb(100%, 38.294983%, 13.243103%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "rgb(100%, 38.63678%, 12.957764%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "rgb(100%, 38.977051%, 12.672424%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "rgb(100%, 39.318848%, 12.387085%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "rgb(100%, 39.659119%, 12.101746%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "rgb(100%, 40.000916%, 11.816406%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "rgb(100%, 40.341187%, 11.531067%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "rgb(100%, 40.682983%, 11.245728%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "rgb(100%, 41.023254%, 10.960388%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "rgb(100%, 41.365051%, 10.673523%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "rgb(100%, 41.705322%, 10.388184%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "rgb(100%, 42.047119%, 10.102844%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "rgb(100%, 42.38739%, 9.817505%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "rgb(100%, 42.729187%, 9.532166%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "rgb(100%, 43.069458%, 9.246826%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "rgb(100%, 43.411255%, 8.961487%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679687,
    stopColor: "rgb(100%, 43.751526%, 8.676147%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "rgb(100%, 44.093323%, 8.390808%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695312,
    stopColor: "rgb(100%, 44.433594%, 8.105469%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "rgb(100%, 44.773865%, 7.820129%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710937,
    stopColor: "rgb(100%, 45.115662%, 7.53479%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "rgb(100%, 45.455933%, 7.249451%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "rgb(100%, 45.797729%, 6.964111%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "rgb(100%, 46.138%, 6.678772%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742187,
    stopColor: "rgb(100%, 46.479797%, 6.393433%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "rgb(100%, 46.820068%, 6.106567%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "rgb(100%, 47.161865%, 5.821228%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "rgb(100%, 47.502136%, 5.535889%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "rgb(100%, 47.843933%, 5.250549%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "rgb(100%, 48.184204%, 4.96521%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "rgb(100%, 48.526001%, 4.679871%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "rgb(100%, 48.866272%, 4.394531%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804688,
    stopColor: "rgb(100%, 49.208069%, 4.109192%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "rgb(100%, 49.54834%, 3.823853%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "rgb(100%, 49.890137%, 3.538513%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "rgb(100%, 50.230408%, 3.253174%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "rgb(100%, 50.572205%, 2.967834%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "rgb(100%, 50.912476%, 2.682495%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851562,
    stopColor: "rgb(100%, 51.254272%, 2.397156%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "rgb(100%, 51.594543%, 2.111816%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "rgb(100%, 51.93634%, 1.826477%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "rgb(100%, 52.276611%, 1.539612%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882812,
    stopColor: "rgb(100%, 52.618408%, 1.254272%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "rgb(100%, 52.958679%, 0.968933%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "rgb(100%, 53.300476%, 0.683594%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "rgb(100%, 53.640747%, 0.398254%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "rgb(100%, 53.965759%, 0.128174%)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(100%, 54.119873%, 0%)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-remove-color)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -76.8,
    y: -76.8,
    width: 921.6,
    height: 921.6,
    fill: "rgb(0%, 0%, 0%)",
    fillOpacity: 0.35
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 0.199219 0.121094 L 245.960938 0.121094 L 245.960938 245.878906 L 0.199219 245.878906 Z M 0.199219 0.121094 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 246,
    height: 246
  })), /*#__PURE__*/React.createElement("g", {
    id: "source-5",
    clipPath: "url(#clip-1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(100%, 83.918762%, 3.919983%)",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    d: "M 180.000334 100.000004 C 180.000334 100.491337 179.988126 100.981653 179.963712 101.471969 C 179.939298 101.962285 179.903695 102.451583 179.855884 102.940882 C 179.807056 103.429163 179.747038 103.916427 179.674813 104.401656 C 179.603605 104.887903 179.519173 105.371098 179.423551 105.852259 C 179.32793 106.334436 179.220101 106.813562 179.101082 107.289637 C 178.982064 107.765711 178.850838 108.238733 178.708423 108.708704 C 178.566007 109.178675 178.411385 109.644577 178.24659 110.106409 C 178.080778 110.569259 177.903776 111.027023 177.716601 111.480718 C 177.52841 111.934412 177.330045 112.383021 177.119474 112.826543 C 176.90992 113.270065 176.689176 113.708501 176.457243 114.14185 C 176.226326 114.5752 175.98422 115.002446 175.731941 115.422572 C 175.479663 115.843714 175.217212 116.258753 174.944588 116.666672 C 174.670947 117.075607 174.389168 117.476405 174.096199 117.871099 C 173.804248 118.265793 173.502124 118.652349 173.189827 119.031784 C 172.878548 119.411219 172.558113 119.782516 172.228523 120.146693 C 171.898933 120.510869 171.560188 120.86589 171.213305 121.212774 C 170.866422 121.560674 170.510384 121.898402 170.147224 122.229009 C 169.783048 122.558599 169.411751 122.879033 169.032315 123.190313 C 168.651863 123.501592 168.265307 123.803716 167.870613 124.096685 C 167.476936 124.388636 167.075121 124.671433 166.667203 124.944056 C 166.259285 125.21668 165.844246 125.479131 165.423103 125.73141 C 165.001961 125.984706 164.574714 126.225795 164.142382 126.457728 C 163.709032 126.688645 163.270596 126.909388 162.827074 127.11996 C 162.382535 127.329514 161.933927 127.528895 161.480232 127.71607 C 161.026537 127.904262 160.568773 128.081263 160.106941 128.246058 C 159.644091 128.411871 159.178189 128.565476 158.708218 128.707891 C 158.238248 128.850306 157.765225 128.981532 157.289151 129.100551 C 156.813077 129.220586 156.333951 129.327398 155.85279 129.424037 C 155.37163 129.519659 154.887417 129.603073 154.402188 129.675298 C 153.915941 129.747523 153.428677 129.807541 152.940396 129.855352 C 152.452115 129.903163 151.962816 129.939784 151.4725 129.964198 C 150.981167 129.987595 150.490851 129.999802 149.999518 129.999802 C 149.509203 129.999802 149.01787 129.987595 148.527554 129.964198 C 148.037238 129.939784 147.54794 129.903163 147.059658 129.855352 C 146.571377 129.807541 146.084113 129.747523 145.597866 129.675298 C 145.112637 129.603073 144.628424 129.519659 144.147264 129.424037 C 143.666103 129.327398 143.186977 129.220586 142.710903 129.100551 C 142.233812 128.981532 141.760789 128.850306 141.291836 128.707891 C 140.821865 128.565476 140.355963 128.411871 139.893113 128.246058 C 139.431281 128.081263 138.973517 127.904262 138.519822 127.71607 C 138.066128 127.528895 137.617519 127.329514 137.17298 127.11996 C 136.729458 126.909388 136.291022 126.688645 135.857672 126.457728 C 135.42534 126.225795 134.998094 125.984706 134.576951 125.73141 C 134.155808 125.479131 133.740769 125.21668 133.332851 124.944056 C 132.924933 124.671433 132.523118 124.388636 132.129441 124.096685 C 131.734747 123.803716 131.348191 123.501592 130.967739 123.190313 C 130.588303 122.879033 130.217006 122.558599 129.85283 122.229009 C 129.489671 121.898402 129.133632 121.560674 128.786749 121.212774 C 128.439866 120.86589 128.101121 120.510869 127.771531 120.146693 C 127.441941 119.782516 127.121506 119.411219 126.80921 119.031784 C 126.497931 118.652349 126.195807 118.265793 125.903855 117.871099 C 125.610886 117.476405 125.329107 117.075607 125.055466 116.666672 C 124.782843 116.258753 124.520391 115.843714 124.268113 115.422572 C 124.015834 115.002446 123.773728 114.5752 123.542812 114.14185 C 123.310878 113.708501 123.090134 113.270065 122.88058 112.826543 C 122.670009 112.383021 122.471645 111.934412 122.283453 111.480718 C 122.095261 111.027023 121.919276 110.569259 121.753464 110.106409 C 121.588669 109.644577 121.434047 109.178675 121.291632 108.708704 C 121.149216 108.238733 121.017991 107.765711 120.898972 107.289637 C 120.779953 106.813562 120.672125 106.334436 120.576503 105.852259 C 120.480881 105.371098 120.396449 104.887903 120.324224 104.401656 C 120.253017 103.916427 120.192999 103.429163 120.144171 102.940882 C 120.09636 102.451583 120.059739 101.962285 120.036342 101.471969 C 120.011928 100.981653 119.999721 100.491337 119.999721 100.000004 C 119.999721 99.508671 120.011928 99.018355 120.036342 98.52804 C 120.059739 98.037724 120.09636 97.548425 120.144171 97.059127 C 120.192999 96.570845 120.253017 96.083581 120.324224 95.598352 C 120.396449 95.112105 120.480881 94.62891 120.576503 94.14775 C 120.672125 93.665572 120.779953 93.186446 120.898972 92.710372 C 121.017991 92.234297 121.149216 91.761275 121.291632 91.291304 C 121.434047 90.821334 121.588669 90.355432 121.753464 89.893599 C 121.919276 89.430749 122.095261 88.972985 122.283453 88.519291 C 122.471645 88.065596 122.670009 87.616988 122.88058 87.173466 C 123.090134 86.729943 123.310878 86.291508 123.542812 85.858158 C 123.773728 85.424808 124.015834 84.997562 124.268113 84.57642 C 124.520391 84.155277 124.782843 83.741255 125.055466 83.333337 C 125.329107 82.924401 125.610886 82.523604 125.903855 82.12891 C 126.195807 81.734216 126.497931 81.34766 126.80921 80.968224 C 127.121506 80.588789 127.441941 80.217492 127.771531 79.853316 C 128.101121 79.489139 128.439866 79.134118 128.786749 78.787235 C 129.133632 78.439334 129.489671 78.101606 129.85283 77.770999 C 130.217006 77.441409 130.588303 77.120975 130.967739 76.809696 C 131.348191 76.498416 131.734747 76.196292 132.129441 75.903323 C 132.523118 75.611372 132.924933 75.328576 133.332851 75.055952 C 133.740769 74.783328 134.155808 74.520877 134.576951 74.268598 C 134.998094 74.015303 135.42534 73.774214 135.857672 73.54228 C 136.291022 73.311364 136.729458 73.09062 137.17298 72.880049 C 137.617519 72.670495 138.066128 72.471113 138.519822 72.283939 C 138.973517 72.095747 139.431281 71.918745 139.893113 71.75395 C 140.355963 71.588138 140.821865 71.434533 141.291836 71.292117 C 141.760789 71.149702 142.233812 71.018476 142.710903 70.899458 C 143.186977 70.779422 143.666103 70.67261 144.147264 70.575971 C 144.628424 70.48035 145.112637 70.396935 145.597866 70.32471 C 146.084113 70.252485 146.571377 70.192467 147.059658 70.144656 C 147.54794 70.095828 148.037238 70.060224 148.527554 70.03581 C 149.01787 70.012413 149.509203 70.000206 149.999518 70.000206 C 150.490851 70.000206 150.981167 70.012413 151.4725 70.03581 C 151.962816 70.060224 152.452115 70.095828 152.940396 70.144656 C 153.428677 70.192467 153.915941 70.252485 154.402188 70.32471 C 154.887417 70.396935 155.37163 70.48035 155.85279 70.575971 C 156.333951 70.67261 156.813077 70.779422 157.289151 70.899458 C 157.765225 71.018476 158.238248 71.149702 158.708218 71.292117 C 159.178189 71.434533 159.644091 71.588138 160.106941 71.75395 C 160.568773 71.918745 161.026537 72.095747 161.480232 72.283939 C 161.933927 72.471113 162.382535 72.670495 162.827074 72.880049 C 163.270596 73.09062 163.709032 73.311364 164.142382 73.54228 C 164.574714 73.774214 165.001961 74.015303 165.423103 74.268598 C 165.844246 74.520877 166.259285 74.783328 166.667203 75.055952 C 167.075121 75.328576 167.476936 75.611372 167.870613 75.903323 C 168.265307 76.196292 168.651863 76.498416 169.032315 76.809696 C 169.411751 77.120975 169.783048 77.441409 170.147224 77.770999 C 170.510384 78.101606 170.866422 78.439334 171.213305 78.787235 C 171.560188 79.134118 171.898933 79.489139 172.228523 79.853316 C 172.558113 80.217492 172.878548 80.588789 173.189827 80.968224 C 173.502124 81.34766 173.804248 81.734216 174.096199 82.12891 C 174.389168 82.523604 174.670947 82.924401 174.944588 83.333337 C 175.217212 83.741255 175.479663 84.155277 175.731941 84.57642 C 175.98422 84.997562 176.226326 85.424808 176.457243 85.858158 C 176.689176 86.291508 176.90992 86.729943 177.119474 87.173466 C 177.330045 87.616988 177.52841 88.065596 177.716601 88.519291 C 177.903776 88.972985 178.080778 89.430749 178.24659 89.893599 C 178.411385 90.355432 178.566007 90.821334 178.708423 91.291304 C 178.850838 91.761275 178.982064 92.234297 179.101082 92.710372 C 179.220101 93.186446 179.32793 93.665572 179.423551 94.14775 C 179.519173 94.62891 179.603605 95.112105 179.674813 95.598352 C 179.747038 96.083581 179.807056 96.570845 179.855884 97.059127 C 179.903695 97.548425 179.939298 98.037724 179.963712 98.52804 C 179.988126 99.018355 180.000334 99.508671 180.000334 100.000004 Z M 180.000334 100.000004 ",
    transform: "matrix(3.84, 0, 0, 3.84, -452.920002, -261)"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(9.01947%, 3.919983%, 18.03894%)",
    fillOpacity: 1,
    d: "M 176.640625 0 L 591.359375 0 C 594.25 0 597.140625 0.0703125 600.027344 0.210938 C 602.914062 0.355469 605.796875 0.566406 608.671875 0.851562 C 611.550781 1.132812 614.417969 1.488281 617.277344 1.910156 C 620.136719 2.335938 622.984375 2.832031 625.820312 3.394531 C 628.65625 3.957031 631.476562 4.589844 634.28125 5.292969 C 637.085938 5.996094 639.871094 6.765625 642.636719 7.605469 C 645.402344 8.445312 648.144531 9.351562 650.867188 10.324219 C 653.589844 11.300781 656.285156 12.339844 658.957031 13.445312 C 661.628906 14.550781 664.269531 15.722656 666.882812 16.960938 C 669.496094 18.195312 672.078125 19.496094 674.628906 20.859375 C 677.175781 22.21875 679.691406 23.644531 682.171875 25.128906 C 684.652344 26.617188 687.09375 28.164062 689.496094 29.769531 C 691.898438 31.375 694.261719 33.039062 696.585938 34.761719 C 698.90625 36.484375 701.183594 38.261719 703.417969 40.09375 C 705.652344 41.929688 707.84375 43.816406 709.984375 45.757812 C 712.125 47.699219 714.21875 49.691406 716.261719 51.738281 C 718.308594 53.78125 720.300781 55.875 722.242188 58.015625 C 724.183594 60.15625 726.070312 62.347656 727.90625 64.582031 C 729.738281 66.816406 731.515625 69.09375 733.238281 71.414062 C 734.960938 73.738281 736.625 76.101562 738.230469 78.503906 C 739.835938 80.90625 741.382812 83.347656 742.867188 85.828125 C 744.355469 88.308594 745.78125 90.824219 747.140625 93.371094 C 748.503906 95.921875 749.804688 98.503906 751.039062 101.117188 C 752.277344 103.730469 753.449219 106.371094 754.554688 109.042969 C 755.660156 111.714844 756.699219 114.410156 757.675781 117.132812 C 758.648438 119.855469 759.554688 122.597656 760.394531 125.363281 C 761.234375 128.128906 762.003906 130.914062 762.707031 133.71875 C 763.410156 136.523438 764.042969 139.34375 764.605469 142.179688 C 765.167969 145.015625 765.664062 147.863281 766.089844 150.722656 C 766.511719 153.582031 766.867188 156.449219 767.148438 159.328125 C 767.433594 162.203125 767.644531 165.085938 767.789062 167.972656 C 767.929688 170.859375 768 173.75 768 176.640625 L 768 591.359375 C 768 594.25 767.929688 597.140625 767.789062 600.027344 C 767.644531 602.914062 767.433594 605.796875 767.148438 608.671875 C 766.867188 611.550781 766.511719 614.417969 766.089844 617.277344 C 765.664062 620.136719 765.167969 622.984375 764.605469 625.820312 C 764.042969 628.65625 763.410156 631.476562 762.707031 634.28125 C 762.003906 637.085938 761.234375 639.871094 760.394531 642.636719 C 759.554688 645.402344 758.648438 648.144531 757.675781 650.867188 C 756.699219 653.589844 755.660156 656.285156 754.554688 658.957031 C 753.449219 661.628906 752.277344 664.269531 751.039062 666.882812 C 749.804688 669.496094 748.503906 672.078125 747.140625 674.628906 C 745.78125 677.175781 744.355469 679.691406 742.867188 682.171875 C 741.382812 684.652344 739.835938 687.09375 738.230469 689.496094 C 736.625 691.898438 734.960938 694.261719 733.238281 696.585938 C 731.515625 698.90625 729.738281 701.183594 727.90625 703.417969 C 726.070312 705.652344 724.183594 707.84375 722.242188 709.984375 C 720.300781 712.125 718.308594 714.21875 716.261719 716.261719 C 714.21875 718.308594 712.125 720.300781 709.984375 722.242188 C 707.84375 724.183594 705.652344 726.070312 703.417969 727.90625 C 701.183594 729.738281 698.90625 731.515625 696.585938 733.238281 C 694.261719 734.960938 691.898438 736.625 689.496094 738.230469 C 687.09375 739.835938 684.652344 741.382812 682.171875 742.867188 C 679.691406 744.355469 677.175781 745.78125 674.628906 747.140625 C 672.078125 748.503906 669.496094 749.804688 666.882812 751.039062 C 664.269531 752.277344 661.628906 753.449219 658.957031 754.554688 C 656.285156 755.660156 653.589844 756.699219 650.867188 757.675781 C 648.144531 758.648438 645.402344 759.554688 642.636719 760.394531 C 639.871094 761.234375 637.085938 762.003906 634.28125 762.707031 C 631.476562 763.410156 628.65625 764.042969 625.820312 764.605469 C 622.984375 765.167969 620.136719 765.664062 617.277344 766.089844 C 614.417969 766.511719 611.550781 766.867188 608.671875 767.148438 C 605.796875 767.433594 602.914062 767.644531 600.027344 767.789062 C 597.140625 767.929688 594.25 768 591.359375 768 L 176.640625 768 C 173.75 768 170.859375 767.929688 167.972656 767.789062 C 165.085938 767.644531 162.203125 767.433594 159.328125 767.148438 C 156.449219 766.867188 153.582031 766.511719 150.722656 766.089844 C 147.863281 765.664062 145.015625 765.167969 142.179688 764.605469 C 139.34375 764.042969 136.523438 763.410156 133.71875 762.707031 C 130.914062 762.003906 128.128906 761.234375 125.363281 760.394531 C 122.597656 759.554688 119.855469 758.648438 117.132812 757.675781 C 114.410156 756.699219 111.714844 755.660156 109.042969 754.554688 C 106.371094 753.449219 103.730469 752.277344 101.117188 751.039062 C 98.503906 749.804688 95.921875 748.503906 93.371094 747.140625 C 90.824219 745.78125 88.308594 744.355469 85.828125 742.867188 C 83.347656 741.382812 80.90625 739.835938 78.503906 738.230469 C 76.101562 736.625 73.738281 734.960938 71.414062 733.238281 C 69.09375 731.515625 66.816406 729.738281 64.582031 727.90625 C 62.347656 726.070312 60.15625 724.183594 58.015625 722.242188 C 55.875 720.300781 53.78125 718.308594 51.738281 716.261719 C 49.691406 714.21875 47.699219 712.125 45.757812 709.984375 C 43.816406 707.84375 41.929688 705.652344 40.09375 703.417969 C 38.261719 701.183594 36.484375 698.90625 34.761719 696.585938 C 33.039062 694.261719 31.375 691.898438 29.769531 689.496094 C 28.164062 687.09375 26.617188 684.652344 25.128906 682.171875 C 23.644531 679.691406 22.21875 677.175781 20.859375 674.628906 C 19.496094 672.078125 18.195312 669.496094 16.960938 666.882812 C 15.722656 664.269531 14.550781 661.628906 13.445312 658.957031 C 12.339844 656.285156 11.300781 653.589844 10.324219 650.867188 C 9.351562 648.144531 8.445312 645.402344 7.605469 642.636719 C 6.765625 639.871094 5.996094 637.085938 5.292969 634.28125 C 4.589844 631.476562 3.957031 628.65625 3.394531 625.820312 C 2.832031 622.984375 2.335938 620.136719 1.910156 617.277344 C 1.488281 614.417969 1.132812 611.550781 0.851562 608.671875 C 0.566406 605.796875 0.355469 602.914062 0.210938 600.027344 C 0.0703125 597.140625 0 594.25 0 591.359375 L 0 176.640625 C 0 173.75 0.0703125 170.859375 0.210938 167.972656 C 0.355469 165.085938 0.566406 162.203125 0.851562 159.328125 C 1.132812 156.449219 1.488281 153.582031 1.910156 150.722656 C 2.335938 147.863281 2.832031 145.015625 3.394531 142.179688 C 3.957031 139.34375 4.589844 136.523438 5.292969 133.71875 C 5.996094 130.914062 6.765625 128.128906 7.605469 125.363281 C 8.445312 122.597656 9.351562 119.855469 10.324219 117.132812 C 11.300781 114.410156 12.339844 111.714844 13.445312 109.042969 C 14.550781 106.371094 15.722656 103.730469 16.960938 101.117188 C 18.195312 98.503906 19.496094 95.921875 20.859375 93.371094 C 22.21875 90.824219 23.644531 88.308594 25.128906 85.828125 C 26.617188 83.347656 28.164062 80.90625 29.769531 78.503906 C 31.375 76.101562 33.039062 73.738281 34.761719 71.414062 C 36.484375 69.09375 38.261719 66.816406 40.09375 64.582031 C 41.929688 62.347656 43.816406 60.15625 45.757812 58.015625 C 47.699219 55.875 49.691406 53.78125 51.738281 51.738281 C 53.78125 49.691406 55.875 47.699219 58.015625 45.757812 C 60.15625 43.816406 62.347656 41.929688 64.582031 40.09375 C 66.816406 38.261719 69.09375 36.484375 71.414062 34.761719 C 73.738281 33.039062 76.101562 31.375 78.503906 29.769531 C 80.90625 28.164062 83.347656 26.617188 85.828125 25.128906 C 88.308594 23.644531 90.824219 22.21875 93.371094 20.859375 C 95.921875 19.496094 98.503906 18.195312 101.117188 16.960938 C 103.730469 15.722656 106.371094 14.550781 109.042969 13.445312 C 111.714844 12.339844 114.410156 11.300781 117.132812 10.324219 C 119.855469 9.351562 122.597656 8.445312 125.363281 7.605469 C 128.128906 6.765625 130.914062 5.996094 133.71875 5.292969 C 136.523438 4.589844 139.34375 3.957031 142.179688 3.394531 C 145.015625 2.832031 147.863281 2.335938 150.722656 1.910156 C 153.582031 1.488281 156.449219 1.132812 159.328125 0.851562 C 162.203125 0.566406 165.085938 0.355469 167.972656 0.210938 C 170.859375 0.0703125 173.75 0 176.640625 0 Z M 176.640625 0 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "url(#linear-pattern-0)",
    strokeMiterlimit: 4,
    d: "M 149.999518 100.000004 L 62.000044 48.000083 L 62.000044 151.999925 L 91.999842 131.999721 L 106.00029 140.000413 L 149.999518 100.000004 ",
    transform: "matrix(3.84, 0, 0, 3.84, 46.079998, 0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#source-5",
    transform: "matrix(1, 0, 0, 1, 499, 261)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 83.918762%, 3.919983%)",
    fillOpacity: 1,
    strokeWidth: 5,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    stroke: "rgb(9.01947%, 3.919983%, 18.03894%)",
    strokeOpacity: 1,
    strokeMiterlimit: 4,
    d: "M 164.999926 100.000004 C 164.999926 100.491337 164.975512 100.981653 164.927701 101.469934 C 164.87989 101.959233 164.807665 102.444462 164.712043 102.92664 C 164.616422 103.407801 164.496386 103.883875 164.353971 104.353845 C 164.211555 104.824833 164.045743 105.286666 163.858569 105.740361 C 163.670377 106.194056 163.460823 106.637578 163.228889 107.070927 C 162.996956 107.504277 162.744677 107.92542 162.472053 108.333338 C 162.199429 108.742273 161.906461 109.13595 161.595181 109.515385 C 161.283902 109.895838 160.954312 110.258997 160.606412 110.606898 C 160.259529 110.953781 159.895352 111.283371 159.515917 111.59465 C 159.136482 111.906946 158.741788 112.198898 158.333869 112.472539 C 157.924934 112.745163 157.503791 112.997441 157.070442 113.228358 C 156.638109 113.460291 156.194587 113.669845 155.739875 113.858037 C 155.28618 114.046229 154.824348 114.211024 154.354377 114.354456 C 153.884406 114.496872 153.408332 114.61589 152.926154 114.711512 C 152.444994 114.807134 151.958747 114.879359 151.470466 114.928187 C 150.981167 114.975998 150.490851 115.000412 149.999518 115.000412 C 149.509203 115.000412 149.018887 114.975998 148.529588 114.928187 C 148.041307 114.879359 147.55506 114.807134 147.0739 114.711512 C 146.591722 114.61589 146.115648 114.496872 145.645677 114.354456 C 145.175706 114.211024 144.713874 114.046229 144.260179 113.858037 C 143.805467 113.669845 143.361945 113.460291 142.928595 113.228358 C 142.496263 112.997441 142.07512 112.745163 141.666185 112.472539 C 141.258266 112.198898 140.863572 111.906946 140.484137 111.59465 C 140.104702 111.283371 139.740526 110.953781 139.393642 110.606898 C 139.045742 110.258997 138.716152 109.895838 138.404873 109.515385 C 138.093593 109.13595 137.800625 108.742273 137.528001 108.333338 C 137.255377 107.92542 137.003099 107.504277 136.771165 107.070927 C 136.539231 106.637578 136.329677 106.194056 136.141486 105.740361 C 135.953294 105.286666 135.788499 104.824833 135.646084 104.353845 C 135.503668 103.883875 135.383632 103.407801 135.288011 102.92664 C 135.192389 102.444462 135.120164 101.959233 135.072353 101.469934 C 135.024542 100.981653 135.000128 100.491337 135.000128 100.000004 C 135.000128 99.508671 135.024542 99.018355 135.072353 98.530074 C 135.120164 98.040776 135.192389 97.555546 135.288011 97.073368 C 135.383632 96.592208 135.503668 96.116134 135.646084 95.646163 C 135.788499 95.175175 135.953294 94.713342 136.141486 94.259647 C 136.329677 93.805953 136.539231 93.362431 136.771165 92.929081 C 137.003099 92.495731 137.255377 92.074589 137.528001 91.66667 C 137.800625 91.257735 138.093593 90.864058 138.404873 90.483606 C 138.716152 90.10417 139.045742 89.741011 139.393642 89.393111 C 139.740526 89.046228 140.104702 88.716638 140.484137 88.404341 C 140.863572 88.093062 141.258266 87.80111 141.666185 87.527469 C 142.07512 87.254846 142.496263 87.002567 142.928595 86.771651 C 143.361945 86.539717 143.805467 86.330163 144.260179 86.141971 C 144.713874 85.95378 145.175706 85.788985 145.645677 85.645552 C 146.115648 85.503137 146.591722 85.384118 147.0739 85.288496 C 147.55506 85.192875 148.041307 85.12065 148.529588 85.071822 C 149.018887 85.024011 149.509203 84.999597 149.999518 84.999597 C 150.490851 84.999597 150.981167 85.024011 151.470466 85.071822 C 151.958747 85.12065 152.444994 85.192875 152.926154 85.288496 C 153.408332 85.384118 153.884406 85.503137 154.354377 85.645552 C 154.824348 85.788985 155.28618 85.95378 155.739875 86.141971 C 156.194587 86.330163 156.638109 86.539717 157.070442 86.771651 C 157.503791 87.002567 157.924934 87.254846 158.333869 87.527469 C 158.741788 87.80111 159.136482 88.093062 159.515917 88.404341 C 159.895352 88.716638 160.259529 89.046228 160.606412 89.393111 C 160.954312 89.741011 161.283902 90.10417 161.595181 90.483606 C 161.906461 90.864058 162.199429 91.257735 162.472053 91.66667 C 162.744677 92.074589 162.996956 92.495731 163.228889 92.929081 C 163.460823 93.362431 163.670377 93.805953 163.858569 94.259647 C 164.045743 94.713342 164.211555 95.175175 164.353971 95.646163 C 164.496386 96.116134 164.616422 96.592208 164.712043 97.073368 C 164.807665 97.555546 164.87989 98.040776 164.927701 98.530074 C 164.975512 99.018355 164.999926 99.508671 164.999926 100.000004 Z M 164.999926 100.000004 ",
    transform: "matrix(3.84, 0, 0, 3.84, 46.079998, 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2de0698f9ed543bef7a53e9067eef098.svg";
export { ForwardRef as ReactComponent };